import {useDispatch, useSelector} from 'react-redux'
import {AppStore} from '../redux/store'
import {
  clearSearch,
  clearSearchDetail,
  setApplicationId,
  setCurrentSearch,
  setCurrentSearchDetail,
} from '../redux/states/khipu'
export const useKhipu = () => {
  const khipuState = useSelector((store: AppStore) => store.khipu)
  const dispatch = useDispatch()
  const changeSearchValues = (search: any) => {
    dispatch(setCurrentSearch(search))
  }
  const setAppId = (id: number) => {
    dispatch(setApplicationId(id))
  }
  const clearSearchValues = () => {
    dispatch(clearSearch())
  }
  const changeSearchValuesDetail = (search: any) => {
    dispatch(setCurrentSearchDetail(search))
  }
  const clearSearchValuesDetail = () => {
    dispatch(clearSearchDetail())
  }

  return {
    applicationId: khipuState.applicationId,
    searchValues: khipuState.searchValues,
    searchValuesDetail: khipuState.searchValuesDetail,
    changeSearchValues,
    clearSearchValues,
    changeSearchValuesDetail,
    clearSearchValuesDetail,
    setAppId,
  }
}
